/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  GameBranding,
  GameBrandingUpdateRequest,
  GameDisplayOrderUpdateRequest,
  GameDisplayOrders,
  GamePromotionalMessage,
  GamePromotionalMessageCreateRequest,
  GamePromotionalMessageUpdateRequest,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    GameBrandingFromJSON,
    GameBrandingToJSON,
    GameBrandingUpdateRequestFromJSON,
    GameBrandingUpdateRequestToJSON,
    GameDisplayOrderUpdateRequestFromJSON,
    GameDisplayOrderUpdateRequestToJSON,
    GameDisplayOrdersFromJSON,
    GameDisplayOrdersToJSON,
    GamePromotionalMessageFromJSON,
    GamePromotionalMessageToJSON,
    GamePromotionalMessageCreateRequestFromJSON,
    GamePromotionalMessageCreateRequestToJSON,
    GamePromotionalMessageUpdateRequestFromJSON,
    GamePromotionalMessageUpdateRequestToJSON,
} from '../models/index';

export interface CreateGamePromotionalMessageRequest {
    customerId: string;
    gameId: string;
    gamePromotionalMessageCreateRequest: GamePromotionalMessageCreateRequest;
    xClientID?: string;
    xRequestID?: string;
}

export interface DeleteGamePromotionalMessageRequest {
    customerId: string;
    gameId: string;
    id: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface GetGamePromotionalMessagesRequest {
    customerId: string;
    gameId: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface SetGameDisplayOrderRequest {
    customerId: string;
    gameDisplayOrderUpdateRequest: GameDisplayOrderUpdateRequest;
    xClientID?: string;
    xRequestID?: string;
}

export interface UpdateGameBrandingRequest {
    customerId: string;
    gameId: string;
    gameBrandingUpdateRequest: GameBrandingUpdateRequest;
    xClientID?: string;
    xRequestID?: string;
}

export interface UpdateGamePromotionalMessageRequest {
    customerId: string;
    gameId: string;
    id: string;
    gamePromotionalMessageUpdateRequest: GamePromotionalMessageUpdateRequest;
    xClientID?: string;
    xRequestID?: string;
}

/**
 * 
 */
export class GamesAdminApi extends runtime.BaseAPI {

    /**
     * Schedule a promotional message against a game.
     */
    async createGamePromotionalMessageRaw(requestParameters: CreateGamePromotionalMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GamePromotionalMessage>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling createGamePromotionalMessage().'
            );
        }

        if (requestParameters['gameId'] == null) {
            throw new runtime.RequiredError(
                'gameId',
                'Required parameter "gameId" was null or undefined when calling createGamePromotionalMessage().'
            );
        }

        if (requestParameters['gamePromotionalMessageCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'gamePromotionalMessageCreateRequest',
                'Required parameter "gamePromotionalMessageCreateRequest" was null or undefined when calling createGamePromotionalMessage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:games"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/games/{gameId}/promotional-messages`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));
        urlPath = urlPath.replace(`{${"gameId"}}`, encodeURIComponent(String(requestParameters['gameId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GamePromotionalMessageCreateRequestToJSON(requestParameters['gamePromotionalMessageCreateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GamePromotionalMessageFromJSON(jsonValue));
    }

    /**
     * Schedule a promotional message against a game.
     */
    async createGamePromotionalMessage(requestParameters: CreateGamePromotionalMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GamePromotionalMessage> {
        const response = await this.createGamePromotionalMessageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Unschedule a promotional message.
     */
    async deleteGamePromotionalMessageRaw(requestParameters: DeleteGamePromotionalMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling deleteGamePromotionalMessage().'
            );
        }

        if (requestParameters['gameId'] == null) {
            throw new runtime.RequiredError(
                'gameId',
                'Required parameter "gameId" was null or undefined when calling deleteGamePromotionalMessage().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteGamePromotionalMessage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:games"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/games/{gameId}/promotional-messages/{id}`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));
        urlPath = urlPath.replace(`{${"gameId"}}`, encodeURIComponent(String(requestParameters['gameId'])));
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Unschedule a promotional message.
     */
    async deleteGamePromotionalMessage(requestParameters: DeleteGamePromotionalMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteGamePromotionalMessageRaw(requestParameters, initOverrides);
    }

    /**
     * Get every promotional message scheduled against a game, past, live and future, oldest window first.
     */
    async getGamePromotionalMessagesRaw(requestParameters: GetGamePromotionalMessagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GamePromotionalMessage>>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getGamePromotionalMessages().'
            );
        }

        if (requestParameters['gameId'] == null) {
            throw new runtime.RequiredError(
                'gameId',
                'Required parameter "gameId" was null or undefined when calling getGamePromotionalMessages().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:games"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/games/{gameId}/promotional-messages`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));
        urlPath = urlPath.replace(`{${"gameId"}}`, encodeURIComponent(String(requestParameters['gameId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GamePromotionalMessageFromJSON));
    }

    /**
     * Get every promotional message scheduled against a game, past, live and future, oldest window first.
     */
    async getGamePromotionalMessages(requestParameters: GetGamePromotionalMessagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GamePromotionalMessage>> {
        const response = await this.getGamePromotionalMessagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Set where games appear in the playslip picker, lowest first. Every listed game is stored together, so a rejected request leaves the existing order untouched.
     */
    async setGameDisplayOrderRaw(requestParameters: SetGameDisplayOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GameDisplayOrders>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling setGameDisplayOrder().'
            );
        }

        if (requestParameters['gameDisplayOrderUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'gameDisplayOrderUpdateRequest',
                'Required parameter "gameDisplayOrderUpdateRequest" was null or undefined when calling setGameDisplayOrder().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:games"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/games/display-order`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: GameDisplayOrderUpdateRequestToJSON(requestParameters['gameDisplayOrderUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GameDisplayOrdersFromJSON(jsonValue));
    }

    /**
     * Set where games appear in the playslip picker, lowest first. Every listed game is stored together, so a rejected request leaves the existing order untouched.
     */
    async setGameDisplayOrder(requestParameters: SetGameDisplayOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GameDisplayOrders> {
        const response = await this.setGameDisplayOrderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace a game\'s branding. Every field is replaced, so one left out of the request is cleared.
     */
    async updateGameBrandingRaw(requestParameters: UpdateGameBrandingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GameBranding>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling updateGameBranding().'
            );
        }

        if (requestParameters['gameId'] == null) {
            throw new runtime.RequiredError(
                'gameId',
                'Required parameter "gameId" was null or undefined when calling updateGameBranding().'
            );
        }

        if (requestParameters['gameBrandingUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'gameBrandingUpdateRequest',
                'Required parameter "gameBrandingUpdateRequest" was null or undefined when calling updateGameBranding().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:games"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/games/{gameId}/branding`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));
        urlPath = urlPath.replace(`{${"gameId"}}`, encodeURIComponent(String(requestParameters['gameId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: GameBrandingUpdateRequestToJSON(requestParameters['gameBrandingUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GameBrandingFromJSON(jsonValue));
    }

    /**
     * Replace a game\'s branding. Every field is replaced, so one left out of the request is cleared.
     */
    async updateGameBranding(requestParameters: UpdateGameBrandingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GameBranding> {
        const response = await this.updateGameBrandingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Change a scheduled message\'s copy or window.
     */
    async updateGamePromotionalMessageRaw(requestParameters: UpdateGamePromotionalMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GamePromotionalMessage>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling updateGamePromotionalMessage().'
            );
        }

        if (requestParameters['gameId'] == null) {
            throw new runtime.RequiredError(
                'gameId',
                'Required parameter "gameId" was null or undefined when calling updateGamePromotionalMessage().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateGamePromotionalMessage().'
            );
        }

        if (requestParameters['gamePromotionalMessageUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'gamePromotionalMessageUpdateRequest',
                'Required parameter "gamePromotionalMessageUpdateRequest" was null or undefined when calling updateGamePromotionalMessage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:games"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/games/{gameId}/promotional-messages/{id}`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));
        urlPath = urlPath.replace(`{${"gameId"}}`, encodeURIComponent(String(requestParameters['gameId'])));
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: GamePromotionalMessageUpdateRequestToJSON(requestParameters['gamePromotionalMessageUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GamePromotionalMessageFromJSON(jsonValue));
    }

    /**
     * Change a scheduled message\'s copy or window.
     */
    async updateGamePromotionalMessage(requestParameters: UpdateGamePromotionalMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GamePromotionalMessage> {
        const response = await this.updateGamePromotionalMessageRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
